const e = "サーチフィールドをクリア", a = "オプションを選択", l = {
  clearSearch: e,
  selectPlaceholder: a,
  "Select.InputSearch.Value:placeholder": "検索",
  "Select.InputSearch.Value:aria-label": "検索"
};
export {
  e as clearSearch,
  l as default,
  a as selectPlaceholder
};
